import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: 'white',
      border: '1px solid #E8DFD2',
      borderRadius: '8px',
      padding: '10px 14px',
      fontSize: '0.82rem',
      boxShadow: '0 4px 12px rgba(92,74,58,0.1)',
    }}>
      <p style={{ fontWeight: 600, color: '#5C4A3A', marginBottom: '4px' }}>{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} style={{ color: p.color }}>
          {p.name}: {p.value !== null ? `${p.value}%` : '—'}
        </p>
      ))}
    </div>
  );
}

export default function ComplianceWellnessChart({ data }) {
  // Subsample if too many data points for readability
  const sampled = data.length > 60
    ? data.filter((_, i) => i % Math.ceil(data.length / 30) === 0 || i === data.length - 1)
    : data;

  return (
    <ResponsiveContainer width="100%" height={240}>
      <LineChart data={sampled} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E8DFD2" />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 11, fill: '#B8A48E' }}
          tickLine={false}
          axisLine={{ stroke: '#E8DFD2' }}
          interval="preserveStartEnd"
        />
        <YAxis
          yAxisId="left"
          domain={[0, 100]}
          tick={{ fontSize: 11, fill: '#B8A48E' }}
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => `${v}%`}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          domain={[0, 100]}
          tick={{ fontSize: 11, fill: '#B8A48E' }}
          tickLine={false}
          axisLine={false}
          tickFormatter={(v) => `${v}%`}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: '0.78rem' }}
          iconSize={10}
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="compliance"
          name="Compliance"
          stroke="#3D7A5E"
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4, fill: '#3D7A5E' }}
          connectNulls
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="wellness"
          name="Wellness"
          stroke="#C2662D"
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4, fill: '#C2662D' }}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
